import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { Truthy as obj2fd } from "obj2fd";

export function GET(url) {
  return axios
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
}

export function POST(url, body, header) {
  const formBody = obj2fd(body);

  return axios({
    method: "post",
    url: url,
    headers: {
      // "Content-Type": "application/json",
    },
    data: formBody,
  })
    .then((res) => {
      // if (res.status === 201 || res.status === 200) {
      return res.data;
      // } else if (res.status === 401) {
      //   return res.data;
      // } else if (res.status === 412) {
      //   return res.data;
      // } else {
      //   return res.data;
      // }
    })
    .catch((err) => {
      if (err.response.status === 500) {
        Swal.fire({
          title: "Server Error",
          text: err.response.statusText,
          type: "info",
          allowOutsideClick: false,
          confirmButtonText: "OK",
        }).then(function (confirm) {
          console.log("logout");
        });
      }
      return err;
    });
}

export function PUT(url, body, header) {
  return axios
    .put(url, body, header)
    .then((res) => {
      // if (res.status === 200) {
      return res.data;
      //   } else if (res.status === 401) {
      //     return res.data;
      //   } else if (res.status === 412) {
      //     return res.data;
      //   } else {
      //     return res.data;
      //   }
    })
    .catch((err) => {
      return err;
    });
}
